import { useContext } from 'react';
//import { __RouterContext } from 'react-router';
import { BrowserRouter } from 'react-router-dom';

//export default () => useContext(__RouterContext);
export default () => useContext(BrowserRouter);
